export function getWorkspaceRoomId(problemId) {
  return `workspace-${problemId}`;
}

